import axios from "axios";
import moment from "moment";

export default {
  new() {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${process.env.LEAD_SERVICE_PUBLIC_PATH}/`
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  get(uuid) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.LEAD_SERVICE_PUBLIC_PATH}/${uuid}`
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error.response));
    });
  },
  save(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "patch",
        url: `${process.env.LEAD_SERVICE_PUBLIC_PATH}/${data.uuid}`,
        data: data
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  saveProspect(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "put",
        url: `${process.env.LEAD_SERVICE_PUBLIC_PATH}/${data.uuid}/prospect`,
        data: data
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getMail(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.LEAD_SERVICE_PUBLIC_PATH}/comparator/${data.uuid}/mail`,
        params: {
          view: data.view,
          lang: data.lang
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getMailByProduct(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${process.env.LEAD_SERVICE_PUBLIC_PATH}/comparator/${data.uuid}/mail`,
        data: data.product
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getPdf(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.LEAD_SERVICE_PUBLIC_PATH}/comparator/${data.uuid}/print`,
        params: {
          view: data.view,
          lang: data.lang,
          customerType: data.customerType
        },
        responseType: 'blob'
      })
        .then((response) => {
          console.log(response.data);
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${data.view}_Mega_${moment().format("YYYY-MM-DD")}.pdf`);
          document.body.appendChild(fileLink);
          fileLink.click();
          resolve(response.data);
        })
        .catch(error => reject(error));
    });
  },
  getPdfByProduct(data) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${process.env.LEAD_SERVICE_PUBLIC_PATH}/comparator/${data.uuid}/print`,
        data: data.product,
        responseType: 'blob'
      })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `ProductMega_${moment().format("YYYY-MM-DD")}.pdf`);
          document.body.appendChild(fileLink);
          fileLink.click();
          resolve(response.data);
        })
        .catch(error => reject(error));
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/leadService.js